export { default } from "./MissionPic";



// WEBPACK FOOTER //
// ./src/components/MissionPic/index.js